import React from 'react';
import {
  injectStripe,
  PaymentRequestButtonElement
} from 'react-stripe-elements';
import II18 from '../translate/II18';
import PropTypes from 'prop-types';

class Wallet extends React.Component {
  constructor(props) {
    super(props);

    const { amount, currency } = this.props;

    // For full documentation of the available paymentRequest options, see:
    // https://stripe.com/docs/stripe.js#the-payment-request-object
    const paymentRequest = props.stripe.paymentRequest({
      country: 'DE',
      currency: currency.toLowerCase(),
      total: {
        label: props.companyName,
        amount: amount * 100
      }
    });

    const {
      stripe,
      stripeClientSecret,
      onPaymentError,
      onPaymentSuccess
    } = this.props;

    paymentRequest.on('paymentmethod', function(ev) {
      // Confirm the PaymentIntent without handling potential next actions (yet).
      console.log('Start payment confirmation:');

      stripe
        .confirmCardPayment(
          stripeClientSecret,
          { payment_method: ev.paymentMethod.id },
          { handleActions: false }
        )
        .then(function(confirmResult) {
          if (confirmResult.error) {
            // Report to the browser that the payment failed, prompting it to
            // re-show the payment interface, or show an error message and close
            // the payment interface.
            console.log('ERROR: ');

            ev.complete('fail');
            onPaymentError();
          } else {
            // Report to the browser that the confirmation was successful, prompting
            // it to close the browser payment method collection interface.
            console.log('CONFIRMED');
            ev.complete('success');

            // Let Stripe.js handle the rest of the payment flow.
            stripe
              .confirmCardPayment(stripeClientSecret)
              .then(function(result) {
                // The payment has been processed!
                if (result.paymentIntent.status === 'succeeded') {
                  onPaymentSuccess();
                } else onPaymentError();
              });
          }
        });
    });

    const thiss = this;
    paymentRequest.canMakePayment().then(result => {
      console.log('canMakePayment result: ');

      thiss.setState({ canMakePayment: !!result });
    });

    this.state = {
      canMakePayment: false,
      paymentRequest
    };
  }

  render() {
    /*const createOptions = (fontSize, padding) => {
      return {
        style: {
          base: {
            fontSize,
            color: '#424770',
            letterSpacing: '0.025em',
            fontFamily: 'Source Code Pro, monospace',
            '::placeholder': {
              color: '#aab7c4'
            },
            padding
          },
          invalid: {
            color: '#9e2146'
          }
        }
      };
    };*/

    return this.state.canMakePayment ? (
      <PaymentRequestButtonElement
        paymentRequest={this.state.paymentRequest}
        className="PaymentRequestButton"
        style={{
          // For more details on how to style the Payment Request Button, see:
          // https://stripe.com/docs/elements/payment-request-button#styling-the-element
          paymentRequestButton: {
            theme: 'light',
            height: '64px'
          }
        }}
      />
    ) : (
      <II18>payment_wallet_not_available</II18>
    );
  }
}

Wallet.propTypes = {
  onPaymentError: PropTypes.func,
  onPaymentSuccess: PropTypes.func,
  stripe: PropTypes.object,
  elements: PropTypes.object,
  fontSize: PropTypes.object,
  currency: PropTypes.string,
  companyName: PropTypes.string,
  stripeClientSecret: PropTypes.string,
  paymentMethodTypes: PropTypes.array,
  amount: PropTypes.number
};

export default injectStripe(Wallet);
